import { render, staticRenderFns } from "./QuitDialog.vue?vue&type=template&id=6fa3ffba&scoped=true"
import script from "./QuitDialog.vue?vue&type=script&lang=js"
export * from "./QuitDialog.vue?vue&type=script&lang=js"
import style0 from "./QuitDialog.vue?vue&type=style&index=0&id=6fa3ffba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa3ffba",
  null
  
)

export default component.exports